import { render } from "./MyDeityPage.vue?vue&type=template&id=667520fd&scoped=true"
import script from "./MyDeityPage.vue?vue&type=script&lang=js"
export * from "./MyDeityPage.vue?vue&type=script&lang=js"

import "./MyDeityPage.vue?vue&type=style&index=0&id=667520fd&lang=scss&scoped=true"

import exportComponent from "D:\\svn_gongzuo\\_____base\\GoPay\\v3_gopay\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-667520fd"]])

export default __exports__